import styled from 'styled-components';
import InstagramEmbed from 'react-instagram-embed';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const InstagramPost = ({ post_id }: { post_id: string }) => (
  <Container>
    <InstagramEmbed
      url={`https://instagr.am/p/${post_id}/`}
      clientAccessToken="546569207165417|f062f56d320f983347e07b75f8393270"
    />
  </Container>
);

export default InstagramPost;
